import React, { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';
import { LoadingScreen } from '@mesa-labs/mesa-ui';

import AuthorizePage from '../components/pages/Authorize';
import SignInOktaPage from '../components/pages/SignInOkta';
import SignInOpsPage from '../components/pages/SignInOps';
import DashboardPage from '../components/pages/Dashboard';
import VendorsPage from '../components/pages/Vendors';
import VendorPage from '../components/pages/Vendor';
import ClientsPage from '../components/pages/Clients';
import ClientPage from '../components/pages/Client';
import InvoiceApprovalsPage from '../components/pages/InvoiceApprovals';
import OktaSecureRoute from './OktaSecureRoute';
import { useSelector } from '../redux/hooks';
import CognitoRoute from './CognitoRoute';
import SignInLayout from '../components/common/SignInLayout';
import { Partners } from '@mesa-labs/mesa-api/dist/types';

function AppRoutes(): ReactElement {
  const isAuthorized = useSelector((state) => state.auth.isAuthorized);
  const logInMethod = useSelector((state) => state.auth.logInMethod);
  const partnerId = useSelector((state) => state.auth.partnerId);

  const DynamicAuthRoute = () => {
    if (logInMethod === 'COGNITO') {
      return <CognitoRoute />;
    }

    return <OktaSecureRoute />;
  };

  return (
    <Routes>
      {process.env.NODE_ENV === 'production' || partnerId === Partners.JLL && (
        <Route path="/" element={<Navigate to="/suppliers" replace />} />
      )}

      <Route path="/sign-in" element={<SignInLayout><SignInOktaPage /></SignInLayout>} />
      <Route path="/sign-in-ops" element={<SignInLayout><SignInOpsPage /></SignInLayout>} />
      <Route path="/oauth" element={<LoginCallback loadingElement={<LoadingScreen />} />} />
      <Route path="/authorize" element={isAuthorized ? <Navigate to="/suppliers" /> : <AuthorizePage />} />

      {process.env.NODE_ENV !== 'production' && partnerId !== Partners.JLL && (
        <Route path="/" element={<DynamicAuthRoute />}>
          <Route path="" element={<DashboardPage />} />
        </Route>
      )}
      <Route path="/suppliers" element={<DynamicAuthRoute />}>
        <Route path="" element={<VendorsPage />} />
        <Route path=":id" element={<VendorPage />} />
      </Route>
      <Route path="/clients" element={<DynamicAuthRoute />}>
        <Route path="" element={<ClientsPage />} />
        <Route path=":id" element={<ClientPage />} />
      </Route>
      {process.env.NODE_ENV !== 'production' && partnerId !== Partners.JLL && (
        <Route path="/" element={<DynamicAuthRoute />}>
          <Route path="invoice-approvals" element={<InvoiceApprovalsPage />} />
        </Route>
      )}
    </Routes>
  );
}

export default AppRoutes;
